import React, { useEffect, useState, useContext } from "react";
import { useNavigateParams } from "../../../hooks/useNavigateParams";

import { Context } from "../../../context/UserContext";

import moment from "moment";
import "moment/locale/pt-br";

/* estilos personalizados */
import styles from "../../form/Form.module.css";

/* formulários personalizados */
import Form from "./Form";
import FormLIM from "./FormLIM";
import FormSER from "./FormSER";

/* hooks */
import useFlashMessage from "../../../hooks/useFlashMessage";

/* api's */
import CRUDsAPI from "../../../api/CRUDs";
import * as EmpresaAPI from "../../../api/empresa";
import * as OperacaoAPI from "../../../api/operacao";

const CreateOrEdit = () => {
    const [dados, setDados] = useState({});
    const [token] = useState(localStorage.getItem("token")) || "";

    const { parametro } = useContext(Context);

    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    const urlParams = new URLSearchParams(window.location.search);

    const pathname = "/Movimento";
    const ul = urlParams.get("ul");
    const li = urlParams.get("li");
    const tipo = urlParams.get("tipo");
    const operacaoId = urlParams.get("operacaoId");
    const operacaoUUID = urlParams.get("operacao");
    const uuid = urlParams.get("uuid");
    const btnText = urlParams.get("btnText");
    const natureza = urlParams.get("natureza");
    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
        natureza: natureza,
    });

    //informações para movimentos novos
    if (!dados.empresaId) {
        dados.empresaId = localStorage.getItem("empresaId");
        dados.empresaIds = localStorage.getItem("empresaIds");
        dados.ativo = true;

        dados.createdAt = moment().format("YYYY-MM-DD HH:mm:ss");
        dados.updatedAt = moment().format("YYYY-MM-DD HH:mm:ss");
        dados.data = moment().format("YYYY-MM-DD 00:00:00");

        //locação
        dados.multa = Number(2).toFixed(2);
        dados.juros = Number(1).toFixed(2);
        dados.diaVencimento = "15";
        dados.condominio = "Locador";
        dados.iptu = "Locador";
        dados.contrato = "Proprietário";
        dados.energia = "Locatário";
        dados.agua = "Locatário";
        dados.locacao = "Comercial";
        dados.entrada = moment().startOf("day").format("YYYY-MM-DD 00:00");
        dados.saida = moment().startOf("day").format("YYYY-MM-DD 00:00");
    }

    const [operacao, setOperacao] = useState({});
    const [operacaoParametros, setOperacaoParametros] = useState({});

    //options
    const [OptionsSituacao, setOptionsSituacao] = useState([]);
    const [OptionsCentroCusto, setOptionsCentroCusto] = useState([]);
    const [OptionsEmpresa, setEmpresa] = useState([]);

    /* funções comuns */
    async function retornaOperacao(uuid) {
        if (!uuid) {
            return;
        }
        try {
            const resultado = await OperacaoAPI.operacao(uuid);
            setOperacao(resultado);

            const data = await OperacaoAPI.retornaOperacaoParametros(resultado.id, dados.empresaId);
            setOperacaoParametros(data);

            return resultado;
        } catch (erro) {
            // Lide com o erro
            console.error(erro);
        }
    }
    /* consulta a situação e centro de custo considerando a operação */
    const consultaSituacao = async (obj) => {
        const { uuid, empresaId } = obj;
        if (!uuid || !empresaId) {
            return [];
        }
        try {
            const result = await OperacaoAPI.situacaoByOperacao(obj);
            setOptionsSituacao(result);
        } catch (error) {
            console.error("Erro ao consultar situação:", error);
        }
    };
    const consultaCentroCusto = async (obj) => {
        const { uuid, empresaId } = obj;
        if (!uuid || !empresaId) {
            return [];
        }
        const result = await OperacaoAPI.centroCustoByOperacao(obj);
        setOptionsCentroCusto(result);
        return result;
    };
    //carregar API's Externas
    const consultaEmpresa = async () => {
        const result = await EmpresaAPI.empresa(dados.empresaId);
        setEmpresa(result);
    };

    /* Obtem a operação */
    useEffect(() => {
        if (operacaoUUID) {
            retornaOperacao(operacaoUUID);

            //para obter a situacao por operacao
            const obj = {
                uuid: operacaoUUID,
                empresaId: dados.empresaId,
            };

            consultaSituacao(obj);
            consultaCentroCusto(obj);
        }

        consultaEmpresa();
    }, [operacaoUUID]);

    useEffect(() => {
        if (!token) {
            return navigate("/Auth", { replace: true });
        }

        if (uuid && uuid !== "null") {
            //consulta a API
            CRUDsAPI.movimento
                .edit(uuid, operacaoId)
                .then((response) => {
                    setDados(response.data);
                })
                .catch((error) => {
                    console.error(error);
                    setFlashMessage(error.response.data.message, error.response.data.type);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [operacao, token, uuid]);

    async function managerDados(obj) {
        let urlNavigate = pathname;
        // Filtra os itens onde pedido é igual a true e atualiza o movimentoItems
        obj.movimentoItems = obj.movimentoItems.filter((item) => item.pedido === true);

        try {
            let response;
            let tempo = 1000; //tempo de exposição da mensagem do flashMessage

            if (uuid && uuid !== "null") {
                response = await CRUDsAPI.movimento.editar(obj);
            } else {
                response = await CRUDsAPI.movimento.cadastrar(obj);

                if (response.status === 202) {
                    setDados(response.data);
                    response.data.message = "Registro em duplicidade!";
                    response.data.type = "warning";
                    urlNavigate = pathname + "/CreateOrEdit";
                    params.set("uuid", response.data.uuid);
                } else if (response.status === 422) {
                    tempo = 3000;
                }
            }

            setFlashMessage(response.data.message, response.data.type);

            setTimeout(() => {
                navigate(urlNavigate, params);
            }, parametro.msgTempo * tempo);
        } catch (error) {
            console.error(error);
            setFlashMessage(error.response.data.message, error.response.data.type);
        }
    }

    return (
        <section className={`${styles.form_container} ${styles[parametro.tema]}`}>
            <>
                {operacao.sigla === "LIM" && (
                    <FormLIM
                        token={token}
                        handleSubmit={managerDados}
                        formData={dados}
                        btnText={btnText}
                        operacao={operacao}
                        operacaoParametros={operacaoParametros}
                        OptionsSituacao={OptionsSituacao}
                        OptionsCentroCusto={OptionsCentroCusto}
                        caminhoVoltar={pathname}
                    />
                )}
                {operacao.sigla === "SER" && (
                    <FormSER
                        token={token}
                        handleSubmit={managerDados}
                        formData={dados}
                        btnText={btnText}
                        operacao={operacao}
                        operacaoParametros={operacaoParametros}
                        OptionsSituacao={OptionsSituacao}
                        OptionsCentroCusto={OptionsCentroCusto}
                        OptionsEmpresa={OptionsEmpresa}
                        caminhoVoltar={pathname}
                    />
                )}
                {["ODC", "PDC", "OPV", "PDV", "CFR"].includes(operacao.sigla) && (
                    <Form
                        token={token}
                        handleSubmit={managerDados}
                        formData={dados}
                        btnText={btnText}
                        operacao={operacao}
                        operacaoParametros={operacaoParametros}
                        OptionsSituacao={OptionsSituacao}
                        OptionsCentroCusto={OptionsCentroCusto}
                        OptionsEmpresa={OptionsEmpresa}
                        caminhoVoltar={pathname}
                    />
                )}
            </>
        </section>
    );
};
export default CreateOrEdit;
